// Dunkles Theme: eigener Cursor, Laufband (die eine führende Bewegung), Wand im ersten Bildschirm und Videos beim Darüberfahren.
// Cursor nur mit Maus und eingeschalteter Bewegung; Laufband steht bei "Bewegung reduzieren" still und lässt sich wischen.
(() => {
  const html = document.documentElement;
  const motion = () => html.classList.contains('motion');
  const designMode = html.classList.contains('design-mode') || Boolean(window.Shopify && window.Shopify.designMode);

  /* ---------- Cursor: Punkt folgt der Maus ohne Verzögerung, wird über Links zum Ring, über Karten zum Kreis mit Wort ---------- */
  const initCursor = () => {
    if (!motion() || designMode || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const el = document.createElement('div');
    el.className = 'cursor';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="cursor__label"></span>';
    document.body.appendChild(el);
    const label = el.firstChild;
    html.classList.add('has-cursor');

    const pos = { seen: false };
    let hotLabel = null;
    let hoverState = '';
    let hoverText = '';
    const apply = () => {
      const text = hotLabel || hoverText;
      const state = hotLabel ? 'is-hot' : hoverState;
      el.className = `cursor${state ? ' ' + state : ''}${pos.seen ? ' is-on' : ''}`;
      label.textContent = state === 'is-label' || state === 'is-hot' ? text : '';
    };
    window.siteCursor = { hot: (text) => { hotLabel = text; apply(); } };

    document.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      // ohne Verzögerung, so schnell wie der normale Mauszeiger
      el.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      if (!pos.seen) {
        pos.seen = true;
        apply();
      }
    }, { passive: true });
    document.addEventListener('pointerover', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const labelled = t && t.closest('[data-cursor]');
      const typing = t && t.closest('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, [contenteditable]');
      const link = t && t.closest('a[href], button, label, select, summary, [role="button"], input[type="checkbox"], input[type="radio"]');
      hoverState = typing ? 'is-hidden' : labelled ? 'is-label' : link ? 'is-link' : '';
      hoverText = labelled ? labelled.dataset.cursor : '';
      apply();
    });
    document.documentElement.addEventListener('mouseleave', () => { pos.seen = false; apply(); });
    document.addEventListener('pointerdown', () => el.classList.add('is-down'));
    document.addEventListener('pointerup', () => el.classList.remove('is-down'));

  };

  /* ---------- Laufband: fährt ohne Halt, Scrollen schiebt mit Faktor 0,3, über dem Band langsamer ---------- */
  const initBand = (band) => {
    const track = band.querySelector('[data-laufband-spur]');
    if (!track || band.__band) return;
    band.__band = true;
    if (!motion()) {
      band.classList.add('is-still');
      return;
    }
    const originals = Array.from(track.children);
    if (!originals.length) return;
    // Kopien, bis die Spur zwei Bildschirmbreiten lang ist; Kopien bleiben klickbar, sind aber für Screenreader und Tastatur unsichtbar
    const copyOf = (item) => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
      return copy;
    };
    const fill = () => {
      let sets = 1;
      const one = () => track.children[originals.length * sets - 1].getBoundingClientRect().right - track.children[0].getBoundingClientRect().left;
      while (one() < window.innerWidth * 2 && sets < 8) {
        originals.forEach((item) => track.appendChild(copyOf(item)));
        sets++;
      }
      // eine zusätzliche Runde, damit beim Zurücksetzen nie eine Lücke entsteht
      originals.forEach((item) => track.appendChild(copyOf(item)));
    };
    fill();
    let setWidth = track.children[originals.length].offsetLeft - track.children[0].offsetLeft;
    window.addEventListener('resize', () => (setWidth = track.children[originals.length].offsetLeft - track.children[0].offsetLeft));

    const speed = Number(band.dataset.speed || 40);
    const factor = Number(band.dataset.scroll || 0.3);
    let offset = 0;
    let pace = 1;
    let lastY = window.scrollY;
    let last = performance.now();
    let visible = false;
    let running = false;
    let paused = false;
    let ueber = false; // statt :hover in jedem Bild abzufragen
    band.addEventListener('pointerenter', () => (ueber = true));
    band.addEventListener('pointerleave', () => (ueber = false));
    band.addEventListener('focusin', () => (paused = true));
    band.addEventListener('focusout', () => (paused = band.contains(document.activeElement)));

    const frame = (now) => {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      const dy = window.scrollY - lastY;
      lastY = window.scrollY;
      pace += ((paused ? 0 : ueber ? 0.25 : 1) - pace) * 0.08;
      offset += speed * dt * pace + dy * factor;
      offset = ((offset % setWidth) + setWidth) % setWidth;
      track.style.transform = `translate3d(${(-offset).toFixed(2)}px, 0, 0)`;
      if (visible) requestAnimationFrame(frame);
      else running = false;
    };
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !running) {
        running = true;
        last = performance.now();
        lastY = window.scrollY;
        requestAnimationFrame(frame);
      }
    }, { rootMargin: '10% 0px' }).observe(band);
  };

  /* ---------- Video beim Darüberfahren (Kacheln im Laufband, Paket-Karten) ---------- */
  const initHoverVideo = (root) => {
    root.querySelectorAll('[data-hover-video]').forEach((box) => {
      if (box.__hv) return;
      box.__hv = true;
      const video = box.querySelector('video');
      if (!video || !motion()) return;
      const start = () => {
        // ab 2,4 s: Vorhang und Einblenden der Beispielseite sind dann vorbei, die Vorschau zeigt gleich die fertige Seite
        if (!video.src) { video.src = video.dataset.src; const skip = () => (video.currentTime = Math.min(2.4, video.duration / 3)); video.loop = false; video.addEventListener('loadedmetadata', skip, { once: true }); video.addEventListener('ended', () => { skip(); video.play().catch(() => {}); }); }
        video.muted = true;
        video.play().then(() => box.classList.add('is-playing')).catch(() => {});
      };
      const stop = () => {
        video.pause();
        box.classList.remove('is-playing');
      };
      const host = box.closest('a, article') || box;
      host.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && start());
      host.addEventListener('pointerleave', stop);
      host.addEventListener('focusin', start);
      host.addEventListener('focusout', stop);
    });
  };

  /* ---------- Erster Bildschirm: Wand aus Beispielseiten neigt sich zur Maus und gleitet beim Scrollen ---------- */
  const initWand = (root) => {
    if (!motion() || root.__wand) return;
    root.__wand = true;
    const plane = root.querySelector('[data-wand-flaeche]');
    if (!plane) return;
    const aim = { x: 0, y: 0 };
    const now = { x: 0, y: 0 };
    let visible = true;
    let running = false;
    window.addEventListener('pointermove', (e) => {
      aim.x = (e.clientX / window.innerWidth) * 2 - 1;
      aim.y = (e.clientY / window.innerHeight) * 2 - 1;
    }, { passive: true });
    const frame = () => {
      now.x += (aim.x - now.x) * 0.08;
      now.y += (aim.y - now.y) * 0.08;
      const top = root.getBoundingClientRect().top;
      plane.style.setProperty('--tilt-y', `${(now.x * 5).toFixed(2)}deg`);
      plane.style.setProperty('--tilt-x', `${(now.y * -4).toFixed(2)}deg`);
      plane.style.setProperty('--lift', `${(top * 0.3).toFixed(1)}px`); // Scrollen: Wand gleitet mit Faktor 0,3
      if (visible) requestAnimationFrame(frame);
      else running = false;
    };
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !running) {
        running = true;
        requestAnimationFrame(frame);
      }
    }).observe(root);
  };

  const init = (root) => {
    root.querySelectorAll('[data-laufband]').forEach(initBand);
    root.querySelectorAll('[data-wand]').forEach(initWand);
    initHoverVideo(document);
  };
  const start = () => {
    initCursor();
    init(document);
  };
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
